<!-- 供应商管理 - 供应商列表 -->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :inline="true" class="demo-form-inline" :model="statusForm" size="small" :ref="statusForm" style="margin: 0">
          <el-form-item label="供应商名称：">
            <el-input size="medium" placeholder="名称" minlength="2" maxlength="10" v-model="statusForm.NAME" clearable
              @keyup.enter.native="filtrate()"></el-input>
          </el-form-item>
          <el-form-item label="企业性质：">
            <el-select size="medium" v-model="statusForm.NATURE_CODE_LIST" filterable placeholder="请选择" clearable style="width: 200px">
              <el-option v-for="item in enterpriseNature" :key="item.value" :label="item.NATURE_NAME" :value="item.NATURE_CODE"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="供应商类型：">
              <el-select filterable v-model="statusForm.STATUS" placeholder="请选择" clearable>
                <el-option v-for="item in supplierType" :key="item.status" :label="item.name" :value="item.status"></el-option>
              </el-select>
            </el-form-item> -->
          <el-form-item label="状态：">
            <label slot="label">状&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;态：</label>
            <el-select size="medium" filterable v-model="statusForm.STATUS" placeholder="请选择">
              <el-option v-for="item in STATUS_LIST" :key="item.status" :label="item.name" :value="item.status">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="评审状态：">
            <el-select size="medium" filterable v-model="statusForm.REVIEW_STATUS" placeholder="请选择" clearable>
              <el-option v-for="item in REVIEW_STATUS_LIST" :key="item.status" :label="item.name" :value="item.status">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="签约状态：">
            <el-select size="medium" filterable v-model="statusForm.SIGN_STATUS" placeholder="请选择" clearable>
              <el-option v-for="item in SIGN_STATUS_LIST" :key="item.status" :label="item.name" :value="item.status">
              </el-option>
            </el-select>
          </el-form-item>
          <el-button size="medium" type="primary" @click="filtrate()" :loading="loadSearch">筛选</el-button>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-button size="medium" @click="openAdd">新增供应商</el-button>
      <el-button size="medium" type="primary" @click="openInvite">邀请供应商入驻</el-button>
      <el-button size="medium" @click="openExport">导入供应商</el-button>
      <el-button size="medium" type="primary" plain @click="exportSupplier">导出供应商</el-button>
      <el-button size="medium" @click="mapExport">匹配供应商</el-button>
      <el-button size="medium" type="primary" plain @click="exportPrice">导出采购价</el-button>
      <el-button size="medium" @click="importProduct">导入采购价</el-button>
      <el-button size="medium" @click="updatePrice" v-show="fun_dic[108000101]" v-if="userPriceType == 1">采购价及订单价更新
      </el-button>
      <el-button size="medium" @click="batchDownShelf" v-if="userPriceType == 2">批量下架产品</el-button>
    </el-row>
    <el-row>
      <el-col>
        <el-tabs type="border-card" @tab-click="handleTabClick" style="margin-top: 20px">
          <el-tab-pane label="已确认供应商">
            <el-table :data="tableData" border stripe style="width: 100%;margin-top: 20px">
              <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
              <el-table-column prop="SUPPLIER_ID" label="供应商ID" min-width="80"></el-table-column>
              <el-table-column prop="NAME" label="供应商名称" min-width="200"></el-table-column>
              <el-table-column prop="AB_NAME" label="简称" min-width="150"></el-table-column>
              <el-table-column prop="CODE" label="字母缩写" min-width="100"></el-table-column>
              <el-table-column prop="COMPANY_CODE" label="企业代码" min-width="170"></el-table-column>
              <el-table-column prop="NATURE_NAME_LIST" label="企业性质" min-width="170">
                <template slot-scope="scope">
                  <span v-for="meal in scope.row.NATURE_NAME_LIST" :key="meal.index">{{ meal }}&nbsp;&nbsp;</span>
                </template>
              </el-table-column>
              <el-table-column prop="CONTACT_NAME" label="联系人" min-width="100"></el-table-column>
              <el-table-column prop="CONTACT_PHONE" label="联系电话" min-width="120"></el-table-column>
              <el-table-column prop="EMAIL" label="联系邮箱" width="200" min-width="100"></el-table-column>
              <el-table-column prop="BANK_NAME" label="开户银行" width="200" min-width="100"></el-table-column>
              <el-table-column prop="BANK_ACCOUNT" label="银行账户" width="200" min-width="100"></el-table-column>
              <el-table-column prop="ADDRESS" label="地址" min-width="150"></el-table-column>
              <el-table-column prop="TAX_CODE" label="财务编码" min-width="100"></el-table-column>

              <el-table-column prop="NUM_OF_FOOD_BUSINESS_LICENSE" label="食品经营许可证编号" min-width="150"></el-table-column>

              <el-table-column label="状态" min-width="120">
                <template slot-scope="scope">
                  <span>{{ showSupplier(scope.row.STATUS) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="签约状态" min-width="120">
                <template slot-scope="scope">
                  <span>{{ showSign(scope.row.SIGN_STATUS) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="评审状态" min-width="120">
                <template slot-scope="scope">
                  <span>{{ showReview(scope.row.REVIEW_STATUS) }}</span>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" min-width="249">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="skuProduct(scope.row)" :disabled="Number(scope.row.STATUS) == 0">
                    查看商品
                  </el-button>
                  <el-button type="text" size="small" :disabled="scope.row.STATUS == 0" @click="edit(scope.row, '修改供应商信息')">
                    修改
                  </el-button>
                  <el-button type="text" size="small" @click="batchDown(scope.row)" v-if="userPriceType == 2">
                    批量下架产品
                  </el-button>
                  <el-button type="text" size="small" v-if="scope.row.STATUS == 0" style="color: rgb(103, 194, 58)" @click="startSupplier(scope.row)">
                    启用
                  </el-button>
                  <el-button type="text" size="small" v-else @click="stopSupplier(scope.row)" style="color: rgb(245, 108, 108)">
                    禁用
                  </el-button>
                  <el-button type="text" size="small" @click="contractManage(scope.row)">
                    资质管理
                  </el-button><br>
                  <el-button type="text" size="small" @click="unmatch(scope.row)">解除匹配</el-button>
                  <el-button type="text" size="small" style="color: #67c23a" @click="editReview(scope.row, 1)" v-if="scope.row.REVIEW_STATUS == 0">
                    已评审
                  </el-button>
                  <el-button type="text" size="small" style="color: #f56c6c" @click="editReview(scope.row, 0)" v-else>
                    未评审
                  </el-button>
                  <el-button type="text" size="small" style="color: #67c23a" @click="editSign(scope.row, 1)" v-if="scope.row.SIGN_STATUS == 0">
                    已签约
                  </el-button>
                  <el-button type="text" size="small" style="color: #f56c6c" @click="editSign(scope.row, 0)" v-else>
                    未签约
                  </el-button>
                  <el-button type="text" size="small" @click="supplyCapacity(scope.row)">
                    供货能力
                  </el-button>
                  <el-button type="text" size="small" @click="setReturnAudit(scope.row)">
                    退货审核设置
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="待审核供应商">
            <el-table :data="tableData" border stripe style="width: 100%; margin-top: 20px">
              <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
              <el-table-column prop="SUPPLIER_ID" label="供应商ID" min-width="80"></el-table-column>
              <el-table-column prop="NAME" label="供应商名称" min-width="200"></el-table-column>
              <el-table-column prop="AB_NAME" label="简称" min-width="150"></el-table-column>
              <el-table-column prop="CODE" label="字母缩写" min-width="100"></el-table-column>
              <el-table-column prop="COMPANY_CODE" label="企业代码" min-width="170"></el-table-column>
              <el-table-column prop="CONTACT_NAME" label="联系人" min-width="100"></el-table-column>
              <el-table-column prop="CONTACT_PHONE" label="联系电话" min-width="120"></el-table-column>
              <el-table-column prop="EMAIL" label="联系邮箱" width="200" min-width="100"></el-table-column>
              <el-table-column prop="BANK_NAME" label="开户银行" width="200" min-width="100"></el-table-column>
              <el-table-column prop="BANK_ACCOUNT" label="银行账户" width="200" min-width="100"></el-table-column>
              <el-table-column prop="ADDRESS" label="地址" min-width="150"></el-table-column>
              <el-table-column prop="TAX_CODE" label="财务编码" min-width="100"></el-table-column>
              <!-- <el-table-column label="是否为集团内部供应商" min-width="120">
                <template slot-scope="scope">
                  <span>{{showSupplier[scope.row.STATUS - 1]}}</span>
                </template>
              </el-table-column> -->
              <el-table-column label="签约状态" min-width="120">
                <template slot-scope="scope">
                  <span>{{ showSign(scope.row.SIGN_STATUS) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="评审状态" min-width="120">
                <template slot-scope="scope">
                  <span>{{ showReview(scope.row.REVIEW_STATUS) }}</span>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" min-width="300">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="sureComing(scope.row)">确认入驻
                  </el-button>
                  <el-button type="text" size="small" @click="delComing(scope.row)">拒绝入驻</el-button>
                  <el-button type="text" size="small" @click="contractManage(scope.row)">
                    资质管理
                  </el-button>
                  <el-button type="text" size="small" style="color: #67c23a" @click="editReview(scope.row, 1)" v-if="scope.row.REVIEW_STATUS == 0">
                    已评审
                  </el-button>
                  <el-button type="text" size="small" style="color: #f56c6c" @click="editReview(scope.row, 0)" v-else>
                    未评审
                  </el-button>
                  <el-button type="text" size="small" style="color: #67c23a" @click="editSign(scope.row, 1)" v-if="scope.row.SIGN_STATUS == 0">
                    已签约
                  </el-button>
                  <el-button type="text" size="small" style="color: #f56c6c" @click="editSign(scope.row, 0)" v-else>
                    未签约
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-col>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
    <!-- 新增/修改供应商模态框 -->
    <el-dialog center :visible.sync="dialogVisible" width="800px" :title="dialogTitle">
      <el-form :model="addForm" ref="addForm" :rules="rules" size="small" :label-width="'140px'" :inline="true">
        <el-form-item label="公司名称：" prop="NAME">
          <el-input v-model="addForm.NAME"></el-input>
        </el-form-item>
        <el-form-item label="公司简称：" prop="AB_NAME">
          <el-input v-model="addForm.AB_NAME"></el-input>
        </el-form-item>
        <!-- <el-form-item label="字母缩写：" prop="CODE">
          <el-input v-model="addForm.CODE"></el-input>
        </el-form-item> -->
        <el-form-item label="企业代码：" prop="COMPANY_CODE">
          <el-input v-model="addForm.COMPANY_CODE"></el-input>
        </el-form-item>
        <el-form-item label="联系人：" prop="CONTACT_NAME">
          <label slot="label">联&nbsp;&nbsp;系&nbsp;&nbsp;人：</label>
          <el-input v-model="addForm.CONTACT_NAME"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" prop="CONTACT_PHONE">
          <el-input v-model="addForm.CONTACT_PHONE" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="开户银行：" prop="BANK_NAME">
          <el-input v-model="addForm.BANK_NAME"></el-input>
        </el-form-item>
        <el-form-item label="银行账号：" prop="BANK_ACCOUNT">
          <el-input v-model="addForm.BANK_ACCOUNT" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="邮箱：" prop="EMAIL">
          <label slot="label">邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱：</label>
          <el-input v-model="addForm.EMAIL"></el-input>
        </el-form-item>
        <el-form-item label="企业性质：" prop="NATURE_CODE_LIST">
          <el-select v-model="addForm.NATURE_CODE_LIST" filterable placeholder="请选择" clearable multiple collapse-tags style="width: 93%">
            <el-option v-for="item in enterpriseNature" :key="item.value" :label="item.NATURE_NAME" :value="item.NATURE_CODE"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="财务编码：" prop="TAX_CODE">
          <el-input v-model="addForm.TAX_CODE" oninput="value=value.replace(/[^0-9a-zA-Z.]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="地址：" prop="ADDRESS">
          <label slot="label">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：</label>
          <el-input v-model="addForm.ADDRESS"></el-input>
        </el-form-item>
        <el-form-item label="结算日期：" prop="BALANCE_CYC">
          <el-select filterable v-model="addForm.BALANCE_CYC" placeholder="请选择结算日" style="width: 93%" clearable>
            <el-option v-for="item in 31" :key="item" :label="item + '日'" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="食品经营许可证编号：" prop="NUM_OF_FOOD_BUSINESS_LICENSE" label-width="150">
          <el-input v-model="addForm.NUM_OF_FOOD_BUSINESS_LICENSE" oninput="value=value.replace(/[^0-9a-zA-Z.]/g,'')"></el-input>
        </el-form-item>
        <el-form-item v-show="dialogFlag == 1" label="供应商类型：">
          <el-radio v-model="addForm.STATUS" label="1">外部供应商</el-radio>
          <el-radio v-model="addForm.STATUS" label="2">内部供应商</el-radio>
          <el-radio v-model="addForm.STATUS" label="3">第三方供应商</el-radio>
        </el-form-item>
        <el-form-item label="是否为应急供应商：" style="display: block">
          <el-radio v-model="addForm.IS_PURCHASE_URGENT" label="1">是</el-radio>
          <el-radio v-model="addForm.IS_PURCHASE_URGENT" label="0">否</el-radio>
        </el-form-item>
        <el-form-item label="录单是否可修改价格" style="display: block">
          <el-radio v-model="addForm.CAN_MODIFY_PRICE" label="1">是</el-radio>
          <el-radio v-model="addForm.CAN_MODIFY_PRICE" label="0">否</el-radio>
        </el-form-item>
        <el-form-item label="资质是否上传到项目" style="display: block">
          <el-radio v-model="addForm.QUA_UPLOAD_TO_PROJECT" label="1">是</el-radio>
          <el-radio v-model="addForm.QUA_UPLOAD_TO_PROJECT" label="0">否</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button size="small" @click="submitAction">确 定</el-button>
      </div>
    </el-dialog>
    <!--导入供应商信息-->
    <el-dialog title="导入供应商" center :visible.sync="addSupplierFormVisible" width="500px">
      <el-form ref="addSupplierForm" v-model="addSupplierForm" style="margin-left: 30px">
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-success="handleSuccess" :on-remove="handleRemove"
          :name="this.addSupplierForm.file" multiple :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <p style="color: #409eff" @click="downloadTmp">点击下载导入模板</p>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addSupplierFormVisible = false">取 消</el-button>
        <el-button @click="submitExport('addSupplierForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 匹配供应商 -->
    <el-dialog title="匹配供应商" center :visible.sync="mapFormVisible" width="500px">
      <el-form :model="mapForm" ref="mapForm" size="small">
        <el-form-item label="供应商名称">
          <el-select id="selectInput" v-model="mapForm.NAME" filterable placeholder="请选择" @change="getLable" multiple collapse-tags
            :filter-method="dataFilter">
            <el-option v-for="item in dataList" :key="item.SUPPLIER_ID" :label="item.NAME" :value="item.SUPPLIER_ID">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="down">取 消</el-button>
        <el-button @click="submitAdd">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导入 -->
    <el-dialog title="导入报价" center :visible.sync="importProductVisible" width="500px">
      <el-form ref="importForm" v-model="importForm" style="margin-left: 30px">
        <el-form-item label="生效日期：" label-width="100px" v-if="userPriceType == 1">
          <el-date-picker v-model="importForm.EFFECTIVE_DATE" align="right" type="date" @change="selectData" placeholder="选择日期"
            value-format="yyyy-MM-dd" :picker-options="pickerOptions1" style="width: 100%">
          </el-date-picker>
        </el-form-item>
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-success="handleSuccess" :on-remove="handleRemove"
          :name="this.importForm.file" multiple :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <p style="color: #409eff" @click="downloadproTmp">点击下载导入模板</p>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importProductVisible = false">取 消</el-button>
        <el-button @click="submitEnter('importForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 更新订单价格 -->
    <el-dialog title="采购价及订单价更新" center :visible.sync="updatePriceVisible" width="500px">
      <el-form ref="updatePriceForm" v-model="updatePriceForm" style="margin-left: 30px">
        <el-form-item label="生效日期：" label-width="100px">
          <el-date-picker v-model="updatePriceForm.EFFECTIVE_DATE" align="right" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
            :picker-options="pickerOptions1" style="width: 100%">
          </el-date-picker>
        </el-form-item>
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-success="handleSuccess" :on-remove="handleRemove"
          :name="this.updatePriceForm.file" multiple :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <p style="color: #409eff" @click="downloadproTmp1">点击下载导入模板</p>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updatePriceVisible = false">取 消</el-button>
        <el-button @click="submitUpdate('importForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 邀请供应商入驻 -->
    <el-dialog title="复制链接邀请供应商入驻系统" center :visible.sync="inviteFormVisible" width="500px">
      <el-form ref="inviteForm" v-model="inviteForm" :inline="true" style="margin-left: 80px">
        <el-form-item style="margin-right: 0px" label="邀请链接：">
          <el-input v-model="urlValue" readonly="readonly"></el-input>
        </el-form-item>
        <el-form-item style="margin-right: 0px" label="入驻配置：">
          <p style="color: #409eff; margin-top: auto; cursor: pointer" @click="openDisposition">
            点击进入入驻配置
          </p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: -30px">
        <el-button @click="inviteFormVisible = false">关 闭</el-button>
        <el-button type="primary" @click="toCopy">复制邀请链接</el-button>
      </div>
    </el-dialog>
    <!-- 顶部的批量下架导入 -->
    <el-dialog title="批量下架" center :visible.sync="batchDownShelfFormVisible" width="400px" :close-on-click-modal="false">
      <el-form size="small" ref="batchDownShelfForm" :model="batchDownShelfForm" style="padding-left: 30px;">
        <el-upload class="upload-demo" action="/uploadFile" :on-success="handleSuccess" :on-remove="handleRemove" :name="this.batchDownShelfForm.file"
          multiple :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过5M</div>
        </el-upload>
        <el-form-item>
          <span @click="downLoadBatchDownShelfTemp" style="color:#409EFF">点此下载导入模板</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close('batchDownShelfForm')">取 消</el-button>
        <el-button size="small" @click="submitBatchDownShelf('batchDownShelfForm')" :loading="loading1">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 列表中的批量下架导入 -->
    <el-dialog title="批量下架" center :visible.sync="batchDownFormVisible" width="400px" :close-on-click-modal="false">
      <el-form size="small" ref="batchDownForm" :model="batchDownForm" style="padding-left: 30px;">
        <el-upload class="upload-demo" action="/uploadFile" :on-success="handleSuccess" :on-remove="handleRemove" :name="this.batchDownForm.file"
          multiple :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过5M</div>
        </el-upload>
        <el-form-item>
          <span @click="downLoadBatchDownTemp" style="color:#409EFF">点此下载导入模板</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close('batchDownForm')">取 消</el-button>
        <el-button size="small" @click="submitBatchDown('batchDownForm')" :loading="loading1">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导出全部报价 -->
    <el-dialog title="导出价格" center :visible.sync="exportPriceVisible" width="430px" :close-on-click-modal="false">
      <el-form ref="exportPriceForm" :model="exportPriceForm" :rules="rules" style="padding-left: 20px;">
        <el-form-item>
          <el-date-picker v-model="exportPriceForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeExportForm">取 消</el-button>
        <el-button size="small" @click="exportAllPrice">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 退货审核设置 -->
    <el-dialog title="退货审核设置" center :visible.sync="returnAuditVisible" width="430px" :close-on-click-modal="false">
      <el-form ref="returnAuditForm" :model="returnAuditForm" :rules="rules" style="padding-left: 20px;">
        <el-form-item label="向供应商退货是否需要审核：">
          <el-switch v-model="returnAuditForm.NEED_APPROVAL" active-text="是" inactive-text="否">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="returnAuditVisible = false">取 消</el-button>
        <el-button size="small" @click="submitReturnAuditSetting">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  supplierList, addSupplier, stopSupplierFun, startSupplierFun, exportSupplierFun, exportSupplier, upSupplierProduct, batchDown,
} from 'api/systemSetting';
import { regionData, CodeToText } from 'element-china-area-data';
import { getActionFun } from 'api/login';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      userPriceType: sessionStorage.getItem('PRICE_MODE'),
      exportPriceVisible: false,
      exportPriceForm: {},
      // loading:false,
      urlValue: '',
      loadSearch: false,
      tableData: [],
      enterpriseNature: [],
      dialogVisible: false,
      inviteFormVisible: false,
      inviteForm: {},
      addForm: {
        CITY: '',
        selectedOptions: [],
        NATURE_CODE_LIST: [],
      },
      addSupplierForm: {
        file: 'tmp',
      },
      mapForm: {
        NAME: [],
        SUPPLIER_ID: [],
      },
      companyList: [],
      options: regionData,
      city: [],
      dialogTitle: '',
      dialogFlag: 0,
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      rules: {
        NAME: [
          { required: true, message: '请输入客户名称', trigger: 'blur' },
        ],
        // CODE: [
        //   { required: true, message: '请输入字母缩写', trigger: 'blur' },
        // ],
        AB_NAME: [
          { required: true, message: '请输入公司别称', trigger: 'blur' },
        ],
        BANK_NAME: [
          { required: true, message: '请输入开户银行', trigger: 'blur' },
        ],
        BANK_ACCOUNT: [
          { required: true, message: '请输入银行账号', trigger: 'blur' },
        ],
      },
      statusForm: {
        STATUS: -1,
      },
      currentOrderFlag: 0,
      addFormVisible: false,
      mapFormVisible: false,
      fileList: [],
      importProductVisible: false,
      importForm: {
        file: 'supplierPrice',
      },
      updatePriceVisible: false,
      updatePriceForm: {
        file: 'tmp',
      },
      PAGE_ID: '1080001', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 108000101: 0 },
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 4 * 8.64e7;// 如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
      batchDownShelfFormVisible: false,
      batchDownShelfForm: {
        file: 'tmp',
      },
      supplierType: [
        {
          name: '禁用',
          status: '0',
        },
        {
          name: '普通供应商',
          status: '1',
        },
        {
          name: '内部供应商',
          status: '2',
        },
        {
          name: '第三方供应商',
          status: '3',
        },
        {
          name: '未审核供应',
          status: '100',
        },
      ],
      loading1: false,
      batchDownFormVisible: false,
      batchDownForm: {
        file: 'tmp',
      },
      addSupplierFormVisible: false,
      REVIEW_STATUS_LIST: [{ status: 2, name: '已评审' }, { status: 1, name: '未评审' }],
      SIGN_STATUS_LIST: [{ status: 2, name: '已签约' }, { status: 1, name: '未签约' }],
      dataList: [],
      oldVal: '',
      oldList: [],
      returnAuditForm: {},
      returnAuditVisible: false,
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    if (JSON.stringify(this.SAVE_SUPPLIER_LIST) != '{}' && this.SAVE_SUPPLIER_LIST != 'undefined') {
      this.statusForm = this.SAVE_SUPPLIER_LIST.CONDITION;
      this.currentPage = this.SAVE_SUPPLIER_LIST.CURRENT_PAGE;
    }
    this.queryEnterprise();
    this.querySupplier();
    this.queryBeforeFun();
  },
  computed: {
    STATUS_LIST() {
      return [{ status: -1, name: '全部' }, { status: 0, name: '禁用' }, { status: 1, name: '普通供应商' }, { status: 2, name: '内部供应商' }, { status: 3, name: '第三方供应商' }];
    },
    SAVE_SUPPLIER_LIST() {
      return this.$store.state.SUPPLIER_LIST;
    },
  },
  methods: {
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // tab切换
    handleTabClick(tab, event) {
      this.currentOrderFlag = Number(tab.index);
      this.querySupplier();
    },
    // --------------------------分页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.querySupplier();
    },
    // ------------------------------查看
    skuProduct(row) {
      this.$router.push({ path: '/skuProducts/detail' });
      sessionStorage.setItem('RELEATION_ID', row.RELEATION_ID);
      sessionStorage.setItem('supplierId', row.SUPPLIER_ID);
      sessionStorage.setItem('supplierNameAboutProducts', row.NAME);
    },
    // -----------------------------筛选
    filtrate() {
      this.currentPage = 1;
      this.querySupplier();
    },
    showSupplier(STATUS) {
      if (STATUS == 0) {
        return '禁用';
      } if (STATUS == 1) {
        return '普通供应商';
      } if (STATUS == 2) {
        return '内部供应商';
      } if (STATUS == 3) {
        return '第三方供应商';
      } if (STATUS == 100) {
        return '未审核';
      }
    },
    showSign(SIGN_STATUS) {
      if (SIGN_STATUS == 0) {
        return '未签约';
      } if (SIGN_STATUS == 1) {
        return '已签约';
      }
    },
    showReview(REVIEW_STATUS) {
      if (REVIEW_STATUS == 0) {
        return '未评审';
      } if (REVIEW_STATUS == 1) {
        return '已评审';
      }
    },
    // 下拉框
    dataFilter(val) {
      this.dataList = val;
      if (val) {
        this.oldVal = val;
        this.dataList = this.companyList.filter((item) => {
          if (item.NAME.includes(val) || item.NAME.toUpperCase().includes(val.toUpperCase())) {
            return true;
          }
        });
        this.oldList = this.dataList;
      } else if (this.oldVal && this.mapForm.NAME.length > 0) {
        this.dataList = this.oldList;
      } else {
        this.dataList = [];
      }
    },
    getLable(row) {
    },
    // -------------------拉取未匹配供应商
    down() {
      this.mapFormVisible = false;
    },
    mapExport() {
      this.mapFormVisible = true;
      this.queryTitle();
    },
    queryTitle() {
      const params = {
        SERVICE_ID: '10001',
        OTYPE: 12,
        GYS_ID: sessionStorage.getItem('tcId'),
      };
      http.post(params).then((result) => {
        this.companyList = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryEnterprise() {
      const params = {
        SERVICE_ID: '10001',
        OTYPE: 16,
        GYS_ID: sessionStorage.getItem('tcId'),
      };
      http.post(params).then((result) => {
        if (result.length !== 0) {
          this.enterpriseNature = result;
        } else {
          this.enterpriseNature = [];
        }
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    async submitAdd() {
      if (this.mapForm.NAME.length == 0) {
        this.$message.show({ text: '请先选择需要匹配的供应商', type: 'warning' });
        return false;
      }
      const paramsList = [];
      const resList = [];
      const erroeList = [];
      let errFlag = 0;
      this.mapForm.NAME.forEach((item, index) => {
        paramsList.push({
          SERVICE_ID: '10001',
          OTYPE: 13,
          GYS_ID: sessionStorage.getItem('tcId'),
          SUPPLIER_ID: item,
        });
      });
      for (const item of paramsList) {
        try {
          // eslint-disable-next-line no-await-in-loop
          const res = await http.post(item);
          resList.push(res);
        } catch (e) {
          erroeList.push(e);
        }
      }
      if (erroeList.length !== 0) {
        errFlag = 2;
        // eslint-disable-next-line no-console
        console.log(erroeList);
      }
      if (errFlag == 0) {
        this.dataList = [];
        this.$message.show({ text: '操作成功', type: 'success' });
      } else {
        this.dataList = [];
        let errText = '';
        let newArr = new Set(erroeList);
        newArr = Array.from(newArr);
        for (const item of newArr) {
          errText = `${item},${errText}`;
        }
        this.$message.show({ text: errText, type: 'error' });
      }
      this.mapFormVisible = false;
      this.mapForm.NAME = '';
      this.mapForm.SUPPLIER_ID = '';
      this.querySupplier();
    },
    stopSupplier(row) {
      this.$confirm('是否禁用该供应商?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const data = {
          SUPPLIER_ID: Number(row.SUPPLIER_ID),
        };
        stopSupplierFun(data).then((res) => {
          this.$message.show({ text: '禁用成功', type: 'success' });
          this.querySupplier();
        }).catch((err) => {
          this.$message.show({ text: err, type: 'err' });
        });
      }).catch(() => {
        this.$message.show({ text: '已取消操作', type: 'warning' });
      });
    },
    startSupplier(row) {
      this.$confirm('是否启用该供应商?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const data = {
          SUPPLIER_ID: Number(row.SUPPLIER_ID),
        };
        startSupplierFun(data).then((res) => {
          this.$message.show({ text: '启用成功', type: 'success' });
          this.querySupplier();
        }).catch((err) => {
          this.$message.show({ text: err, type: 'success' });
        });
      }).catch(() => {
        this.$message.show({ text: '已取消操作', type: 'warning' });
      });
    },
    // ------------------------------修改-----------------新增
    handleAddSupplier(e) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const data = {
            NAME: this.addForm.NAME,
            AB_NAME: this.addForm.AB_NAME,
            COMPANY_CODE: this.addForm.COMPANY_CODE,
            ADDRESS: this.addForm.ADDRESS,
            CONTACT_NAME: this.addForm.CONTACT_NAME,
            CONTACT_PHONE: this.addForm.CONTACT_PHONE,
            EMAIL: this.addForm.EMAIL,
            TAX_CODE: this.addForm.TAX_CODE,
            BALANCE_CYC: this.addForm.BALANCE_CYC,
            STATUS: Number(this.addForm.STATUS) ? Number(this.addForm.STATUS) : 1,
            IS_PURCHASE_URGENT: Number(this.addForm.IS_PURCHASE_URGENT) === 0 || Number(this.addForm.IS_PURCHASE_URGENT) === 1 ? Number(this.addForm.IS_PURCHASE_URGENT) : 0,
            BANK_NAME: this.addForm.BANK_NAME,
            BANK_ACCOUNT: this.addForm.BANK_ACCOUNT,
            CAN_MODIFY_PRICE: this.addForm.CAN_MODIFY_PRICE,
            QUA_UPLOAD_TO_PROJECT: this.addForm.QUA_UPLOAD_TO_PROJECT,
            NUM_OF_FOOD_BUSINESS_LICENSE: this.addForm.NUM_OF_FOOD_BUSINESS_LICENSE,
          };
          if (this.addForm.RELEATION_ID) {
            data.RELEATION_ID = this.addForm.RELEATION_ID;
          }
          if (this.addForm.NATURE_CODE_LIST && this.addForm.NATURE_CODE_LIST.length !== 0) {
            data.NATURE_CODE_LIST = this.addForm.NATURE_CODE_LIST;
          } else {
            data.NATURE_CODE_LIST = [];
          }
          if (!this.addForm.NAME || !this.addForm.AB_NAME || !this.addForm.BANK_NAME || !this.addForm.BANK_ACCOUNT) {
            this.$message.show({ text: '请将带*号的信息填写完整', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          addSupplier(data, e).then((res) => {
            this.$message.show({ text: '操作成功', type: 'success' });
            this.dialogVisible = false;
            this.querySupplier();
            this.queryEnterprise();
            document.body.style.cursor = 'default';
          }).catch((err) => {
            this.$message.show({ text: err, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // ----------------拉取数据
    querySupplier() {
      const params = {
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: this.pageSize,
        STATUS: this.statusForm.STATUS,
      };
      if (this.statusForm.NAME) {
        params.SUPPLIER_NAME = this.statusForm.NAME;
      }
      if (this.currentOrderFlag == 1) {
        params.STATUS = 100;
      }
      if (this.statusForm.NATURE_CODE_LIST) {
        const NATURE_CODE_LIST = [];
        NATURE_CODE_LIST.push(Number(this.statusForm.NATURE_CODE_LIST));
        params.NATURE_CODE_LIST = NATURE_CODE_LIST;
      }
      if (this.statusForm.REVIEW_STATUS) {
        params.REVIEW_STATUS = this.statusForm.REVIEW_STATUS - 1;
      }
      if (this.statusForm.SIGN_STATUS) {
        params.SIGN_STATUS = this.statusForm.SIGN_STATUS - 1;
      }
      this.loadSearch = true;
      supplierList(params)
        .then((res) => {
          if (res.length !== 0) {
            this.tableData = res[0].list;
            this.totalCount = res[0].TOTAL_COUNT;
            this.$store.dispatch('SET_SUPPLIER_LIST', {
              CONDITION: this.statusForm,
              CURRENT_PAGE: this.currentPage,
            });
            const starturl = window.location.origin;
            this.urlValue = `${starturl}/SCM/#/settledSupplierRegister/${Number(sessionStorage.getItem('tcId'))}`;
            // this.urlValue = `https://service.linkda.com.cn/SMP/#/settledSupplierRegister/${Number(sessionStorage.getItem('tcId'))}`;
            // this.urlValue = `http://101.132.129.64/SMP/#/settledSupplierRegister/${Number(sessionStorage.getItem('tcId'))}`;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
          this.loadSearch = false;
        }).catch((err) => {
          this.loadSearch = false;
          this.$message.show({ text: err, type: 'error' });
        });
    },
    // ------------------关闭
    close() {
      this.dialogVisible = false;
      this.batchDownShelfFormVisible = false;
      this.batchDownFormVisible = false;
    },
    openAdd() {
      this.dialogVisible = true;
      this.dialogFlag = 0;
      this.dialogTitle = '新增供应商';
      this.addForm = {};
      this.addForm.selectedOptions = [];
    },
    handleChangeCity(e) {
      this.city = [];
      e.map((item) => {
        const code = CodeToText[item.toString()];
        this.city.push(code);
      });
      this.addForm.CITY = this.city.join('/');
    },
    edit(row) {
      this.dialogVisible = true;
      this.dialogFlag = 1;
      this.dialogTitle = '修改供应商';
      this.addForm = { ...row };
      const arr = [];
      if (row.NATURE_CODE_LIST !== '') {
        row.NATURE_CODE_LIST.map((item) => {
          arr.push(Number(item));
        });
      }

      this.addForm.selectedOptions = [];
      this.addForm.STATUS = row.STATUS.toString();
      this.addForm.NATURE_CODE_LIST = arr;
      this.addForm.IS_PURCHASE_URGENT = row.IS_PURCHASE_URGENT.toString();
      this.addForm.CAN_MODIFY_PRICE = row.CAN_MODIFY_PRICE.toString();
      this.addForm.QUA_UPLOAD_TO_PROJECT = row.QUA_UPLOAD_TO_PROJECT.toString();
    },
    // -------------------------判断是修改还是新增
    submitAction() {
      // this.loading = true
      if (this.dialogFlag === 0) {
        this.handleAddSupplier(4);
      } else {
        this.handleAddSupplier(3);
      }
    },
    openExport() {
      this.addSupplierFormVisible = true;
    },
    submitExport() {
      if (!this.url) {
        this.$message.show({ text: '请先上传文件', type: 'warning' });
        return false;
      }
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            FILE_NAME: this.url,
          };
          exportSupplierFun(params).then((result) => {
            if (result[0].FILE_PATH) {
              this.$message.show({ text: '导入失败，详情查看下载文件', type: 'error' });
              document.body.style.cursor = 'default';
              window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            }
            this.$message.show({ text: '导入成功', type: 'success' });
            this.addSupplierFormVisible = false;
            this.url = '';
            this.$refs.upload.clearFiles();
            this.fileList = [];
            this.querySupplier();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: '导入失败，详情查看下载文件', type: 'error' });
            this.url = '';
            this.$refs.upload.clearFiles();
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    handleSuccess(response, file, fileList) {
      this.url = response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.url = '';
    },
    downloadTmp() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/GYSsupplierTmp.xlsx';
    },
    contractManage(row) {
      this.$router.push({ path: '/supplierLicense/detail' });
      sessionStorage.setItem('supplierId', row.SUPPLIER_ID);
      sessionStorage.setItem('supplierNameAboutLicense', row.NAME);
    },
    // 解除匹配
    unmatch(row) {
      this.$confirm('解除供应商供应关系会解除该供应商的所有商品供应关系，是否确定解除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '10001',
          OTYPE: 15,
          USER_ID: sessionStorage.getItem('userId'),
          SESSION: sessionStorage.getItem('session'),
          GYS_ID: Number(sessionStorage.getItem('tcId')),
          RELEATION_ID: row.RELEATION_ID,
          PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
        };
        http.post(params)
          .then((result) => {
            this.$message.show({ text: '解除成功', type: 'success' });
            this.querySupplier();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      });
    },
    // 修改评审状态
    editReview(row, review) {
      const params = {
        SERVICE_ID: '10001',
        OTYPE: 18,
        RELEATION_ID: row.RELEATION_ID,
        REVIEW_STATUS: review,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.querySupplier();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 修改签约状态
    editSign(row, sign) {
      const params = {
        SERVICE_ID: '10001',
        OTYPE: 19,
        RELEATION_ID: row.RELEATION_ID,
        SIGN_STATUS: sign,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.querySupplier();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 价格导出
    exportPrice() {
      if (this.userPriceType == 2) {
        this.exportPriceVisible = true;
      } else {
        this.exportAllPrice();
      }
    },
    exportAllPrice() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10008',
            OTYPE: 34,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            PRICE_MODE: this.userPriceType,
          };
          if (this.userPriceType == 2) {
            if (this.exportPriceForm.DAY_INTERVAL) {
              params.START_DAY = this.exportPriceForm.DAY_INTERVAL[0];
              params.END_DAY = this.exportPriceForm.DAY_INTERVAL[1];
            } else {
              this.$message.show({ text: '请选择日期', type: 'warning' });
              return false;
            }
          }
          http.post(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
        }
      }
    },
    // 更新价格
    updatePrice() {
      this.updatePriceVisible = true;
    },
    // 导入模态框的提交
    submitUpdate() {
      if (!this.url || !this.updatePriceForm.EFFECTIVE_DATE) {
        this.$message.show({ text: '请上传文件并输入日期', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10008',
        OTYPE: 36,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        EFFECTIVE_DATE: this.updatePriceForm.EFFECTIVE_DATE,
        FILE_NAME: this.url,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '更新成功', type: 'success' });
        this.url = '';
        this.$refs.upload.clearFiles();
        this.updatePriceVisible = false;
        this.fileList = [];
        this.querySupplier();
        document.body.style.cursor = 'default';
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.url = '';
        this.$refs.upload.clearFiles();
        document.body.style.cursor = 'default';
      });
    },
    // 导入报价
    importProduct() {
      this.importProductVisible = true;
    },
    selectData(e) {
      this.importForm.EFFECTIVE_DATE = e;
    },
    downloadproTmp() {
      if (this.userPriceType == 1) {
        window.location.href = 'https://service.linkda.com.cn/file/templates/gysImpProductPriceTemp.xlsx';
      } else {
        window.location.href = 'https://service.linkda.com.cn/file/templates/MvendorpriceTemp.xls';
      }
    },
    downloadproTmp1() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/updateTdaysPrice.xlsx';
    },
    // 导入模态框的提交
    submitEnter() {
      if (this.userPriceType == 1) {
        if (!this.url || !this.importForm.EFFECTIVE_DATE) {
          this.$message.show({ text: '请上传文件并输入生效日期', type: 'warning' });
          return false;
        }
      } else {
        if (!this.url) {
          this.$message.show({ text: '请上传文件', type: 'warning' });
          return false;
        }
      }
      const params = {
        SERVICE_ID: '10008',
        OTYPE: 35,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        EFFECTIVE_DATE: this.importForm.EFFECTIVE_DATE,
        FILE_NAME: this.url,
        PRICE_MODE: this.userPriceType,
      };
      http.post(params)
        .then((result) => {
          if (result[0].FILE_PATH == '') {
            this.$message.show({ text: '导入成功', type: 'success' });
            this.url = '';
            this.$refs.upload.clearFiles();
            this.importProductVisible = false;
            this.fileList = [];
            this.querySupplier();
            document.body.style.cursor = 'default';
          } else {
            this.$message.show({ text: '部分产品导入异常，详情查看下载文件', type: 'error' });
            this.url = '';
            this.$refs.upload.clearFiles();
            this.importProductVisible = false;
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            this.fileList = [];
            document.body.style.cursor = 'default';
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.url = '';
          this.$refs.upload.clearFiles();
          document.body.style.cursor = 'default';
        });
    },
    // 邀请供应商入驻
    openInvite() {
      this.inviteFormVisible = true;
    },
    // 进入入驻界面
    inviteInterface() {
      this.$router.push({ path: `/settledSupplierRegister/${sessionStorage.getItem('tcId')}`, params: { id: sessionStorage.getItem('tcId') } });
    },
    // 进去入驻配置界面
    openDisposition() {
      this.$router.push({ name: 'settledDisposition' });
    },
    // 复制链接按钮
    toCopy() {
      const input = document.createElement('input');
      input.value = this.urlValue;
      document.body.appendChild(input);
      input.select();
      document.execCommand('Copy');
      document.body.removeChild(input);
      this.$message.show({ text: '链接已复制', type: 'success' });
    },
    // 确认入驻
    sureComing(row) {
      const params = {
        SERVICE_ID: '10002',
        OTYPE: 22,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SUPPLIER_ID: row.SUPPLIER_ID,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '确认入驻成功', type: 'success' });
        this.querySupplier();
      });
    },
    delComing(row) {
      const params = {
        SERVICE_ID: '10002',
        OTYPE: 23,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SUPPLIER_ID: row.SUPPLIER_ID,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '解除入驻成功', type: 'success' });
        this.querySupplier();
      });
    },
    // 导出供应商
    exportSupplier() {
      exportSupplier().then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    batchDownShelf() {
      this.batchDownShelfFormVisible = true;
    },
    downLoadBatchDownShelfTemp() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/pm2ucmProductstemp.xls';
    },
    submitBatchDownShelf() {
      if (!this.url) {
        this.$message.show({ text: '请上传文件', type: 'warning' });
        return false;
      }
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            FILE_NAME: this.url,
          };
          this.loading1 = true;
          upSupplierProduct(params).then((result) => {
            this.$message.show({ text: '下架成功', type: 'success' });
            this.batchDownShelfFormVisible = false;
            this.loading1 = false;
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            this.loading1 = false;
            document.body.style.cursor = 'default';
          });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    // 批量下架
    batchDown(row) {
      this.batchDownForm = {
        SUPPLIER_ID: row.SUPPLIER_ID,
        file: 'tmp',
      };
      this.batchDownFormVisible = true;
    },
    downLoadBatchDownTemp() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/ucProductstemp.xls';
    },
    submitBatchDown() {
      if (!this.url) {
        this.$message.show({ text: '请上传文件', type: 'warning' });
        return false;
      }
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          // 执行代码
          const params = {
            FILE_NAME: this.url,
            VENDOR_ID: Number(this.batchDownForm.SUPPLIER_ID),
          };
          this.loading1 = true;
          batchDown(params).then((result) => {
            this.$message.show({ text: '下架成功', type: 'success' });
            this.batchDownFormVisible = false;
            this.loading1 = false;
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            this.loading1 = false;
            document.body.style.cursor = 'default';
          });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    closeExportForm() {
      this.exportPriceVisible = false;
    },
    supplyCapacity(row) {
      this.$router.push({ path: `/supplyCapacity/${row.SUPPLIER_ID}`, params: { sid: row.SUPPLIER_ID } });
      sessionStorage.setItem('supplierNameAboutCapacity', row.NAME);
    },
    businessReferencePrice(row) {
      this.$router.push({ path: `/businessReferencePrice/${row.SUPPLIER_ID}`, params: { sid: row.SUPPLIER_ID } });
    },
    setReturnAudit(row) {
      this.returnAuditForm = { SUPPLIER_ID: row.SUPPLIER_ID, NEED_APPROVAL: Boolean(row.NEED_APPROVAL) };
      this.returnAuditVisible = true;
    },
    submitReturnAuditSetting() {
      const params = {
        SERVICE_ID: '10020',
        OTYPE: 19,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SUPPLIER_ID: this.returnAuditForm.SUPPLIER_ID,
        NEED_APPROVAL: this.returnAuditForm.NEED_APPROVAL ? 1 : 0,
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '设置成功', type: 'success' });
        this.returnAuditVisible = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/supplierManage/supplierManage.vue